import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useState } from 'react';
import { useTranslation } from "react-i18next";

const AddNewKeyModal = ({ show, onAdd, onClose }) => {
    const [translate] = useTranslation();
    const [key, setKey] = useState("");

    return (
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">
                {translate("OTM_ADD_KEY")}
                <Button onClick={onClose} variant="danger" className="btn-sm">{translate("OTM_CLOSE")}</Button>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                <label className="h6">
                    {translate("OTM_KEY_NAME")}
                </label>
                <input className="form-control form-control-sm col" type="string" onChange={(event) => setKey(event.target.value)}></input>
                <Button onClick={() => onAdd(key)} variant="primary" className="btn-sm mt-3">{translate("OTM_ADD")}</Button>
            </BootstrapModal.Body>
        </BootstrapModal>
    );
};

export default AddNewKeyModal;
